export default "__VITE_ASSET__2e09a763__"